<button class="close-round" mat-dialog-close>
  <span class="close-round__btn"></span>
</button>

<svg-icon-sprite src="./assets/img/icons/sprite.svg#hint"></svg-icon-sprite>
<h1 translate="verification-modal.title.skip"></h1>
<p [translate]="data.text"></p>
<btn
  [wide]="true"
  buttonText="verification-modal.button.continue"
  mat-dialog-close
></btn>
<btn
  [wide]="true"
  [blueBorder]="true"
  buttonText="verification-modal.button.skip"
  mat-dialog-close
  routerLink="/dashboard"
></btn>
